import React from 'react';
import {connect} from "react-redux";
import Pagination from 'react-js-pagination';
import Select from 'react-select';

import ArticleFilter from './ArticleFilter';
import ItemList from './ItemList';
import ResultCount from '../components/List/ResultCount';
import CreateArticleModal from "./CreateArticleModal";

import {
    updateQuery,
    changePage,
    setPageSize,
    fetchArticles,
    updateErpIdno,
    updateGtin,
    updateName,
    updateVendorArticleNumber,
    updateSortProperty,
    createNewArticle
} from './reducer';

export class ArticleManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            articleModalVisible: false
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.hideArticleModal = this.hideArticleModal.bind(this);
        this.showArticleModal = this.showArticleModal.bind(this);
        this.createNewArticle = this.createNewArticle.bind(this);
    }

    handlePageChange(newPage) {
        this.props.changePage(newPage - 1);
    }

    componentDidMount() {
        this.props.fetchArticles();
    }

    showArticleModal() {
        this.setState({articleModalVisible: true});
    }

    hideArticleModal() {
        this.setState({articleModalVisible: false});
    }

    createNewArticle(article) {
        this.props.createNewArticle(article);
        this.hideArticleModal();
    }

    render() {
        return (
                <div className="animated fadeIn" style={{fontSize: 'small'}}>
                    <CreateArticleModal visible={this.state.articleModalVisible}
                                         onSubmit={this.createNewArticle}
                                         onCancel={this.hideArticleModal}/>
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Artikelverwaltung</h4>
                            <div className="row">
                                <div className="col-lg-10">
                                    <ArticleFilter query={this.props.query}
                                                   updateQuery={this.props.updateQuery}/>
                                </div>
                                <div className="col-12">
                                    <button type="button" className="btn btn-light float-right"
                                            onClick={this.showArticleModal}>
                                        <i className="fa fa-plus-circle"/>&nbsp;neuer Artikel
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                                 end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.articles.length}
                                                 total={this.props.pagination.totalElements}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <ItemList items={this.props.articles}
                                              propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                              sortDirection={this.props.sortProperties.sortDirection}
                                              updateErpIdno={this.props.updateErpIdno}
                                              updateGtin={this.props.updateGtin}
                                              updateName={this.props.updateName}
                                              updateVendorArticleNumber={this.props.updateVendorArticleNumber}
                                              updateSortProperty={this.props.updateSortProperty}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <Pagination
                                            activePage={this.props.pagination.page + 1}
                                            itemsCountPerPage={this.props.pagination.pageSize}
                                            totalItemsCount={this.props.pagination.totalElements}
                                            pageRangeDisplayed={20}
                                            onChange={this.handlePageChange}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-2 pull-left">
                                    <Select
                                            name="pageSize"
                                            value={this.props.pagination.pageSize}
                                            onChange={(select) => this.props.setPageSize(select.value)}
                                            options={[
                                                {value: '25', label: '25'},
                                                {value: '50', label: '50'},
                                                {value: '100', label: '100'},
                                                {value: '200', label: '200'},
                                                {value: '1000', label: '1000'}
                                            ]}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                                 end={(this.props.pagination.page) * this.props.pagination.pageSize + this.props.articles.length}
                                                 total={this.props.pagination.totalElements}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        articles: state.article.get('articles').toJS(),
        query: state.article.get('query'),
        pagination: state.article.get('pagination').toJS(),
        sortProperties: state.article.get('sortProperties').toJS()
    };
}

const ConnectedArticleManager = connect(mapStateToProps, {
    updateQuery,
    changePage,
    setPageSize,
    fetchArticles,
    updateGtin,
    updateName,
    updateVendorArticleNumber,
    updateErpIdno,
    updateSortProperty,
    createNewArticle
})(ArticleManager);

export default ConnectedArticleManager;


// WEBPACK FOOTER //
// ./src/admin/article/ArticleManager.js